
export default function PersonalInfoSection({ values, onChange, errors, isLocked }) {
  return (
    <section>
      <h2 className="text-xl font-bold text-primary mb-4">Dine informationer</h2>
      <div className="space-y-4">

        {/* Fulde Navn */}
        <div>
          <label className="block font-bold text-primary mb-1" htmlFor="customer_name">
            Fulde navn
          </label>
          <input
            id="customer_name"
            name="customer_name"
            type="text"
            autoComplete="name"
            className={`w-full rounded-form border border-gray-300 px-4 py-3 bg-primary-light focus:outline-none focus:ring-2 focus:ring-accent text-primary font-medium transition ${isLocked ? 'bg-gray-100 cursor-not-allowed' : ''}`}
            value={values.customer_name || ''}
            readOnly={isLocked}
            onChange={e => !isLocked && onChange('customer_name', e.target.value)}
            placeholder="f.eks. navn navnesen"
            required
          />
          {errors.customer_name && (
            <p className="text-red-600 text-sm mt-1">{errors.customer_name}</p>
          )}
        </div>

        {/* Projektadresse */}
        <div>
          <label className="block font-bold text-primary mb-1" htmlFor="address">
            Projektadresse
          </label>
          <input
            id="address"
            name="address"
            type="text"
            autoComplete="address"
            className={`w-full rounded-form border border-gray-300 px-4 py-3 bg-primary-light focus:outline-none focus:ring-2 focus:ring-accent text-primary font-medium transition ${isLocked ? 'bg-gray-100 cursor-not-allowed' : ''}`}
            value={values.address || ''}
            readOnly={isLocked}
            onChange={e => !isLocked && onChange('address', e.target.value)}
            placeholder="Tilfældigvej 123, 2500 Valby"
            required
          />
          {errors.address && (
            <p className="text-red-600 text-sm mt-1">{errors.address}</p>
          )}
        </div>

        {/* E-mail */}
        <div>
          <label className="block font-bold text-primary mb-1" htmlFor="mail">
            E-mail
          </label>
          <input
            id="mail"
            name="mail"
            type="email"
            autoComplete="email"
            className={`w-full rounded-form border border-gray-300 px-4 py-3 bg-primary-light focus:outline-none focus:ring-2 focus:ring-accent text-primary font-medium transition ${isLocked ? 'bg-gray-100 cursor-not-allowed' : ''}`}
            value={values.mail || ''}
            readOnly={isLocked}
            onChange={e => !isLocked && onChange('mail', e.target.value)}
            placeholder="f.eks. hej@mail.dk"
            required
          />
          {errors.mail && (
            <p className="text-red-600 text-sm mt-1">{errors.mail}</p>
          )}
        </div>

        {/* Telefonnummer */}
        <div>
          <label className="block font-bold text-primary mb-1" htmlFor="phone">
            Telefonnummer
          </label>
          <input
            id="phone"
            name="phone"
            type="tel"
            autoComplete="tel"
            className={`w-full rounded-form border border-gray-300 px-4 py-3 bg-primary-light focus:outline-none focus:ring-2 focus:ring-accent text-primary font-medium transition ${isLocked ? 'bg-gray-100 cursor-not-allowed' : ''}`}
            value={values.phone || ''}
            readOnly={isLocked}
            onChange={e => !isLocked && onChange('phone', e.target.value)}
            placeholder="f.eks. 12345678"
            required
          />
          {errors.phone && (
            <p className="text-red-600 text-sm mt-1">{errors.phone}</p>
          )}
        </div>

        {/* Firma/Privat Selection */}
        <div className="mt-6 pt-4 border-t border-gray-200">
          <div className="mb-4">
            <label className="block font-bold text-primary mb-1">Er du privat eller firma?</label>
            <div className="flex gap-4">
              <label className="flex items-center gap-2 cursor-pointer">
                <input
                  type="radio"
                  name="is_company"
                  value="false"
                  checked={values.is_company === 'false'}
                  onChange={() => onChange('is_company', 'false')}
                  className="accent-accent"
                  required
                />
                <span className="text-primary">Privat</span>
              </label>
              <label className="flex items-center gap-2 cursor-pointer">
                <input
                  type="radio"
                  name="is_company"
                  value="true"
                  checked={values.is_company === 'true'}
                  onChange={() => onChange('is_company', 'true')}
                  className="accent-accent"
                  required
                />
                <span className="text-primary">Firma</span>
              </label>
            </div>
            {errors.is_company && (
              <p className="text-red-600 text-sm mt-1">{errors.is_company}</p>
            )}
          </div>

          {/* Conditional field for Privat - Home Address */}
          {values.is_company === 'false' && (
            <div className="mb-4">
              <label className="block font-bold text-primary mb-1" htmlFor="home_address">
                Hjemmeadresse
              </label>
              <input
                id="home_address"
                name="home_address"
                type="text"
                className="w-full rounded-form border border-gray-300 px-4 py-3 bg-primary-light focus:outline-none focus:ring-2 focus:ring-accent text-primary font-medium"
                value={values.home_address || ''}
                onChange={e => onChange('home_address', e.target.value)}
                placeholder="Tilfældigvej 123, 2500 Valby"
                required
              />
              {errors.home_address && (
                <p className="text-red-600 text-sm mt-1">{errors.home_address}</p>
              )}
            </div>
          )}

          {/* Conditional field for Firma - CVR Number */}
          {values.is_company === 'true' && (
            <div className="mb-4">
              <label className="block font-bold text-primary mb-1" htmlFor="cvr_number">
                CVR-nummer
              </label>
              <input
                id="cvr_number"
                name="cvr_number"
                type="number"
                className="w-full rounded-form border border-gray-300 px-4 py-3 bg-primary-light focus:outline-none focus:ring-2 focus:ring-accent text-primary font-medium"
                value={values.cvr_number || ''}
                onChange={e => onChange('cvr_number', e.target.value)}
                placeholder="12345678"
                maxLength="8"
                required
              />
              {errors.cvr_number && (
                <p className="text-red-600 text-sm mt-1">{errors.cvr_number}</p>
              )}
            </div>
          )}
        </div>

        {/* Contact Person Override Section */}
        <div className="mt-6 pt-4 border-t border-gray-200">
          <div className="mb-4">
            <label className="flex items-center gap-2 cursor-pointer">
              <input
                type="checkbox"
                name="same_contact_person"
                checked={values.same_contact_person === 'true'}
                onChange={e => onChange('same_contact_person', e.target.checked ? 'true' : 'false')}
                className="accent-accent"
              />
              <span className="text-primary font-bold">Kontaktpersonen er den samme som ovenfor</span>
            </label>
          </div>

          {/* Contact person override fields - shown when checkbox is NOT checked */}
          {values.same_contact_person !== 'true' && (
            <div className="space-y-4">
              <h4 className="text-md font-bold text-primary mb-2">Kontaktperson</h4>

              {/* Overwritten Name */}
              <div>
                <label className="block font-bold text-primary mb-1" htmlFor="overwritten_name">
                  Navn på kontaktperson
                </label>
                <input
                  id="overwritten_name"
                  name="overwritten_name"
                  type="text"
                  className="w-full rounded-form border border-gray-300 px-4 py-3 bg-primary-light focus:outline-none focus:ring-2 focus:ring-accent text-primary font-medium"
                  value={values.overwritten_name || ''}
                  onChange={e => onChange('overwritten_name', e.target.value)}
                  placeholder="f.eks. Navn Navnesen"
                  required
                />
                {errors.overwritten_name && (
                  <p className="text-red-600 text-sm mt-1">{errors.overwritten_name}</p>
                )}
              </div>

              {/* Overwritten Email */}
              <div>
                <label className="block font-bold text-primary mb-1" htmlFor="overwritten_mail">
                  E-mail
                </label>
                <input
                  id="overwritten_mail"
                  name="overwritten_mail"
                  type="email"
                  className="w-full rounded-form border border-gray-300 px-4 py-3 bg-primary-light focus:outline-none focus:ring-2 focus:ring-accent text-primary font-medium"
                  value={values.overwritten_mail || ''}
                  onChange={e => onChange('overwritten_mail', e.target.value)}
                  placeholder="f.eks. Mail Mailsen"
                  required
                />
                {errors.overwritten_mail && (
                  <p className="text-red-600 text-sm mt-1">{errors.overwritten_mail}</p>
                )}
              </div>

              {/* Overwritten Phone */}
              <div>
                <label className="block font-bold text-primary mb-1" htmlFor="overwritten_phone">
                  Telefonnummer
                </label>
                <input
                  id="overwritten_phone"
                  name="overwritten_phone"
                  type="tel"
                  className="w-full rounded-form border border-gray-300 px-4 py-3 bg-primary-light focus:outline-none focus:ring-2 focus:ring-accent text-primary font-medium"
                  value={values.overwritten_phone || ''}
                  onChange={e => onChange('overwritten_phone', e.target.value)}
                  placeholder="f.eks. 12345678"
                  required
                />
                {errors.overwritten_phone && (
                  <p className="text-red-600 text-sm mt-1">{errors.overwritten_phone}</p>
                )}
              </div>
            </div>
          )}
        </div>
      </div>
    </section>
  );
}
